import Icon from '../../../components/AppIcon';

const SavedReportsList = ({ reports, onSelect, selectedReport }) => {
  const getScheduleIcon = (frequency) => {
    switch (frequency) {
      case 'daily':
        return 'Calendar';
      case 'weekly':
        return 'CalendarDays';
      case 'monthly':
        return 'CalendarRange';
      default:
        return 'Clock';
    }
  };

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-semibold text-foreground px-3 py-2">Saved Reports</h4>
      {reports?.map((report) => (
        <div
          key={report?.id}
          onClick={() => onSelect(report)}
          className={`p-3 rounded-lg cursor-pointer transition-all duration-200 ${
            selectedReport?.id === report?.id
              ? 'bg-primary/10 border border-primary' :'bg-card hover:bg-muted/50 border border-transparent'
          }`}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e?.key === 'Enter' || e?.key === ' ') {
              e?.preventDefault();
              onSelect(report);
            }
          }}
        >
          <div className="flex items-start justify-between mb-2">
            <h5 className="font-medium text-sm text-foreground">{report?.name}</h5>
            {report?.scheduled && (
              <Icon
                name={getScheduleIcon(report?.frequency)}
                size={14}
                color="var(--color-accent)"
              />
            )}
          </div>
          <p className="text-xs text-muted-foreground mb-2">{report?.description}</p>
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span className="flex items-center gap-1">
              <Icon name="User" size={12} />
              {report?.createdBy}
            </span>
            <span>{report?.lastRun}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SavedReportsList;